// **  Initial State
const initialState = {
  parent_leads: [],
  parent_city_outlets: [],
  ew_batch_leads: [],
  batch_wise_region_leads: [],
  isLoading: false,
};

const EWLeadsReducer = (state = initialState, action) => {
  if (action.type === "GET_PARENT_LEADS") {
    return { ...state, parent_leads: action.payload, isLoading: false };
  }

  if (action.type === "GET_PARENT_CITY_OUTLETS") {
    return { ...state, parent_city_outlets: action.payload, isLoading: false };
  }

  if (action.type === "GET_EW_BATCH_LEADS") {
    return { ...state, ew_batch_leads: action.payload, isLoading: false };
  }

  if (action.type === "GET_REGIONAL_ZONAL_LEADS") {
    return {
      ...state,
      regional_zonal_leads: action.payload,
      isLoading: false,
    };
  }

  return state;
};

export default EWLeadsReducer;
